module.exports = __webpack_public_path__ + "img/ss_recentlyadded copy.aaaf3eed.png";